module.exports = __webpack_public_path__ + "static/media/warning-panda.c0afc2d1.png";